import { Button } from '@mui/material';
import styled from '@emotion/styled';

const SecondaryButton = styled(Button)(({ theme }) => ({
    borderRadius: theme.spacing(1.5),
    padding: theme.spacing(1.5, 4),
    fontWeight: 600,
    fontSize: '1rem',
    textTransform: 'none',
    background: `linear-gradient(135deg, ${theme.palette.warning.light} 0%, ${theme.palette.warning.contrastText} 100%)`,
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
        background: `linear-gradient(135deg, ${theme.palette.warning.main} 0%, ${theme.palette.warning.contrastText} 100%)`,
    },
    '&:disabled': {
        background: theme.palette.grey[300],
        color: theme.palette.grey[600],
        transform: 'none',
        boxShadow: 'none',
    },
}));

export default SecondaryButton;
